import 'expose?$!expose?jQuery!jquery'
import bootstrap from 'bootstrap'

import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import firebase  from 'firebase'
import VueNotie from 'vue-notie'

import Home from './components/Home'

import Blog from './components/Blog'
import PostListado from './components/Post-Listado'
import PostEdit from './components/Post-Edit'

import Suscripciones from './components/Suscripciones'

import Registros from './components/Registros'

import './assets/css/bootstrap.min.css'
import 'notie/dist/notie.min.css'

Vue.use(VueRouter)
Vue.use(VueNotie)

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: Home },
    { path: '/blog', component: Blog, },
    { path: '/postedit/:id?', name: 'postEdit', component: PostEdit},
    { path: '/registros', component: Registros },
    { path: '/suscripciones', component: Suscripciones },
  ]
})


new Vue({
  el: '#app',
  router,
  render: h => h(App),
})


// WEBPACK FOOTER //
// ./E:/dev/repos/wpo_sitecontrol/src/main.js